import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import {
  GET_STORES,
  UPDATE_CART,
  ADD_ID_RETAILER,
  CART_TOTAL,
  CART_LOADING,
  SUCCESS_ORDER,
  GET_CART_VARIANTS,
  UPDATE_CART_VARIANTS,
  CART_LOADING_FORM,
  CART_ERROR,
} from '../constants/cartTypes';

const initialState = {
  stores: [],
  variants: [],
  cartsData: [],
  quantitySuppliers: [],
  total: 0,
  isLoading: false,
  isLoadingForm: false,
  userId: 0,
  error: null,
};

const cart = (state = initialState, action) => {
  switch (action.type) {
    case GET_STORES:
      return {
        ...state,
        stores: action.payload,
      };
    case GET_CART_VARIANTS:
      return {
        ...state,
        variants: action.payload,
      };
    case UPDATE_CART_VARIANTS:
      return {
        ...state,
        variants: state.variants.map((variant) => {
          if (action.payload.variantId === variant.id) {
            variant.quantity = action.payload.quantity;
          }
          return variant;
        }),
      };
    case UPDATE_CART:
      return {
        ...state,
        cartsData: [...state.cartsData].map((userRetailerCart) => {
          if (
            action.payload.retailer_id === userRetailerCart.retailer_id &&
            action.payload.user_id === userRetailerCart.user_id
          ) {
            userRetailerCart.variants = action.payload.variants;
            return userRetailerCart;
          }
          return userRetailerCart;
        }),
      };
    case SUCCESS_ORDER:
      return {
        ...state,
        cartsData: [...state.cartsData].map((userRetailerCart) => {
          if (
            action.payload.retailerId === userRetailerCart.retailer_id &&
            action.payload.userId === userRetailerCart.user_id
          ) {
            userRetailerCart.variants = {};
            return userRetailerCart;
          }
          return userRetailerCart;
        }),
        error: null,
      };
    case CART_TOTAL:
      return {
        ...state,
        cartsData: [...state.cartsData].map((item) => {
          if (action.payload.retailerId === item.retailerId && action.payload.userId === item.userId) {
            item.total = action.payload.total;
            item.sub_total = action.payload.sub_total;
            item.shipping_cost = action.payload.shipping_cost;
            return item;
          }
          return item;
        }),
      };
    case CART_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case CART_LOADING_FORM:
      return {
        ...state,
        isLoadingForm: action.payload,
      };
    case ADD_ID_RETAILER:
      return {
        ...state,
        cartsData: [
          ...state.cartsData,
          { retailer_id: action.payload.retailerId, variants: {}, user_id: action.payload.userId },
        ],
      };
    case CART_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      break;
  }

  return state;
};

const persistConfig = {
  key: 'cart',
  storage: storage,
  whitelist: ['cartsData'],
};

export default persistReducer(persistConfig, cart);
